import React, { FC, useCallback } from "react";

import { SuggestedBadge } from "@/components/Badge";
import { Text } from "@/components/Text";
import { ISkill } from "@/data/skills";

interface ISuggestedSkillBadgeProps {
  skill: ISkill;
  isChecked?: boolean;
  onClick?: (skill: ISkill) => void;
  onCheckedClick?: (skill: ISkill) => void;
}

export const SuggestedSkillBadge: FC<ISuggestedSkillBadgeProps> = ({ skill, isChecked, onClick, onCheckedClick }) => {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(skill);
    }
  }, [onClick]);

  const handleCheckedClick = useCallback(() => {
    if (onCheckedClick) {
      onCheckedClick(skill);
    }
  }, [onCheckedClick]);

  return (
    <SuggestedBadge isChecked={isChecked} onClick={isChecked ? handleCheckedClick : handleClick} notCheckedIcon="add">
      <Text size="md">{skill.name}</Text>
    </SuggestedBadge>
  );
};
